enum PortStatus {
    PENDING = 'Porting Pending',
    COMPLETE = 'Porting Complete',
    ISSUE = 'Porting Issue',
    NOT_PORTING = '',
}

export { PortStatus };
